import { ListChronoUnits } from './ListChronoUnits';

/**
 * queries
 *
 * @type {{ListChronoUnits: ((function({}=): Promise<*>)|*)}}
 */
export const queries = {
  ListChronoUnits,
};
